export default __webpack_public_path__ + "static/media/Screenshot_18.24dbb33c.png";